import { useState, useEffect, useCallback } from "react";
import "@/App.css";
import axios from "axios";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import NuestraHistoria from "./components/NuestraHistoria";
import PorQuePuraMadre from "./components/PorQuePuraMadre";
import ComoUsarla from "./components/ComoUsarla";
import ProductShowcase from "./components/ProductShowcase";
import RecipeGallery from "./components/RecipeGallery";
import Newsletter from "./components/Newsletter";
import InstagramGrid from "./components/InstagramGrid";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import CheckoutOverlay from "./components/CheckoutOverlay";
import { Toaster, toast } from "sonner";

const API = "/api";

function App() {
  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);
  const [checkoutOpen, setCheckoutOpen] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/products`)
      .then((res) => setProducts(res.data))
      .catch(console.error);
  }, []);

  const addToCart = useCallback((product) => {
    setCart((prev) => {
      const existing = prev.find((item) => item.id === product.id);
      if (existing) {
        return prev.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      return [...prev, { ...product, quantity: 1 }];
    });
    toast.success(`${product.name} agregado al carrito`, {
      style: {
        background: "#262626",
        color: "#F5F5F0",
        border: "1px solid rgba(212, 175, 55, 0.3)",
      },
    });
  }, []);

  const updateQty = useCallback((id, qty) => {
    if (qty <= 0) {
      setCart((prev) => prev.filter((item) => item.id !== id));
      return;
    }
    setCart((prev) =>
      prev.map((item) => (item.id === id ? { ...item, quantity: qty } : item))
    );
  }, []);

  const removeItem = useCallback((id) => {
    setCart((prev) => prev.filter((item) => item.id !== id));
  }, []);

  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  const scrollToProducts = () => {
    const el = document.querySelector("#products");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#1A1A1A" }}>
      <Toaster position="top-right" />
      <Navbar
        cartCount={cartCount}
        onCartOpen={() => setCartOpen(true)}
      />
      <main>
        <HeroSection onShopNow={scrollToProducts} />
        <NuestraHistoria />
        <PorQuePuraMadre />
        <ComoUsarla />
        <ProductShowcase products={products} onAddToCart={addToCart} />
        <RecipeGallery />
        <Newsletter />
        <InstagramGrid />
      </main>
      <Footer />
      <CartDrawer
        open={cartOpen}
        onClose={() => setCartOpen(false)}
        cart={cart}
        onUpdateQty={updateQty}
        onRemove={removeItem}
        onCheckout={() => {
          setCartOpen(false);
          setTimeout(() => setCheckoutOpen(true), 300);
        }}
      />
      <CheckoutOverlay
        open={checkoutOpen}
        onClose={() => setCheckoutOpen(false)}
        cart={cart}
        onPaymentComplete={() => {
          setCheckoutOpen(false);
          setCart([]);
          toast.success("¡Pedido completado!", {
            style: {
              background: "#262626",
              color: "#F5F5F0",
              border: "1px solid rgba(74, 124, 89, 0.3)",
            },
          });
        }}
      />
    </div>
  );
}

export default App;
